export default angular.module('eventix.common.services.whitelabelTemplateOverrides', [])
    .factory('WhitelabelTemplateOverrides',  WhitelabelTemplateOverrides).name;

function WhitelabelTemplateOverrides($window, $http, Company, $transitions, $state, $compile, $interval, $q, $injector, $log) {
    $window.templateOverride = function(overrides) {
        _.forEach(overrides, override => {
            let to = _.get(override, 'state.name', override.state);
            if(!angular.isString(to))
                return;
            $transitions.onSuccess({
                entering: to
            }, function($trans) {
                if(_.has(override, 'state.params') && !_.matches(override.state.params)($trans.params()))
                    return;
                applyOverride(override);
            });
        });
    };

    if(OVERRIDE_JS_NAME != '') {
        let url = `${ NODE_ENV === 'production' ? DASHBOARD_ROOT + '/build' : '//localhost:8080/build' }/${ OVERRIDE_JS_NAME }.js`;
        return $http.jsonp(url).catch(error => {
            if(error && error.status === 404)
                return;
        });
    }

    function applyOverride(override) {
        waitFor(override.where).then(target => {
            let injection;
            if(angular.isString(override.what))
                injectHtml(override.what, override.how, target);
            else if(angular.isFunction(override.what) || angular.isArray(override.what)) {
                injection = $injector.invoke(override.what, null, { $scope: target.scope() });
                if(angular.isString(injection))
                    injectHtml(injection, override.how, target);
                else if(angular.isObject(injection) && 'then' in injection) {
                    return injection.then(injection => {
                        if(angular.isString(injection))
                            injectHtml(injection, override.how, target);
                    });
                }
            }
            return $q.resolve();
        }).catch(error => {
            $log.info('Override failed', override, error);
            console.error(`Override failed: ${JSON.stringify(_.omit(override, 'what'))}.`, error);
        });
    }

    function injectHtml(what, how, target) {
        what = $compile(what)(target.scope());
        switch(how) {
            case 'prepend':
                target.prepend(what);
                break;
            case 'replace':
                target.replace(what);
                break;
            case 'before':
                target.before(what);
                break;
            case 'after':
                target.after(what);
                break;
            case 'append':
                target.append(what);
                break;
            default:
                break;
        }
    }

    function waitFor(selector, timeout = 1000) {
        var deferred = $q.defer();
        var counter = timeout / 50;
        var interval = $interval(() => {
            counter--;
            let target = angular.element(selector);
            if(target.length || counter < 0) {
                $interval.cancel(interval);
                deferred[target.length ? 'resolve' : 'reject'](target.length ? target : 'TargetNotFound');
            }
        }, 50);
        return deferred.promise;
    }
    return {};
}
